import { LinkedInError } from './LinkedInError'

export class ExceedsLimitLinkedInError extends LinkedInError {
	#code: string

	constructor(message: string, code: string, metadata?: unknown) {
		super(message, metadata)
		this.name = 'ExceedsLimitLinkedInError'
		this.#code = code

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, ExceedsLimitLinkedInError)
		}
	}

	get Code(): string {
		return this.#code
	}
}
